const valor_inicial = {
  Nome: '',
  Id: '',
};

export { valor_inicial };
